import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c53c2afe"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "slot-modal calendar-modal",
  id: "slot-modal"
}
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { for: "product-select" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "caret-custom-icon" }, null, -1))
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { for: "product-select" }
const _hoisted_7 = { class: "form-group row" }
const _hoisted_8 = { class: "col-sm-4 oneRowInMobile" }
const _hoisted_9 = { for: "product-select" }
const _hoisted_10 = { class: "col-sm-4 col-6" }
const _hoisted_11 = { for: "product-select" }
const _hoisted_12 = { class: "col-sm-4 col-6" }
const _hoisted_13 = { for: "product-select" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { for: "slot-limit" }
const _hoisted_16 = {
  class: "d-flex align-items-center",
  style: {"height":"42px"}
}
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "mx-2" }
const _hoisted_19 = { class: "pt-2" }
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-12" }
const _hoisted_23 = { class: "d-flex slot-selling-options" }
const _hoisted_24 = ["disabled", "checked"]
const _hoisted_25 = { class: "pl-2 slot-setting-title" }
const _hoisted_26 = { class: "pl28" }
const _hoisted_27 = ["disabled", "checked"]
const _hoisted_28 = { class: "pl-2 slot-setting-title" }
const _hoisted_29 = { class: "row no-gutters" }
const _hoisted_30 = { class: "col-12 pt20 pb13" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "caret-custom-icon" }, null, -1))
const _hoisted_32 = {
  key: 0,
  class: "col-12",
  style: {"padding-top":"20px"}
}
const _hoisted_33 = { style: {"column-gap":"20px","display":"grid","grid-template-columns":"2fr 1fr"} }
const _hoisted_34 = { class: "w-100" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "caret-custom-icon" }, null, -1))
const _hoisted_36 = {
  class: "form-group",
  style: {"position":"relative"}
}
const _hoisted_37 = { for: "slot-limit" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_TimeInput = _resolveComponent("TimeInput")!
  const _component_RadioInput = _resolveComponent("RadioInput")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_OverlayModal = _resolveComponent("OverlayModal")!

  return (_openBlock(), _createBlock(_component_OverlayModal, {
    isOpen: _ctx.isOpen,
    "onUpdate:isOpen": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.isOpen) = $event)),
    contentClass: "modal-limit"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('calendar.v3.modal.product')), 1),
          _createVNode(_component_Multiselect, {
            class: _normalizeClass(["slot-modal-multiselect_calendar custom-multiselect-input", { invalid: _ctx.invalid.productId }]),
            modelValue: _ctx.slot.productId,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.slot.productId) = $event)),
            placeholder: _ctx.$t('stopSale.selectProduct'),
            options: _ctx.products,
            disabled: !!_ctx.slot.id || !!_ctx.slot.originalSlotId || !_ctx.isProductEditable,
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setProductOrderBlockMinutes($event)))
          }, {
            caret: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["modelValue", "placeholder", "options", "class", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('calendar.v3.modal.start_date')), 1),
          _createVNode(_component_Calendar, {
            modelValue: _ctx.slot.startDate,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.slot.startDate) = $event)),
            selectionMode: "single",
            dateFormat: "dd/mm/yy",
            required: "",
            "min-date": _ctx.canCreateChangeSlotInPast ? null : new Date(),
            disabled: _ctx.slot.originalSlotId ? true : false,
            class: _normalizeClass([{
        invalid: _ctx.invalid.startDate
    }, "slot-modal-calendar"])
          }, null, 8, ["modelValue", "min-date", "disabled", "class"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('calendar.v3.modal.start_time')), 1),
            _createVNode(_component_TimeInput, {
              class: "slot-modal-timeInput",
              modelValue: _ctx.slot.startTime,
              "onUpdate:modelValue": [
                _cache[3] || (_cache[3] = ($event: any) => ((_ctx.slot.startTime) = $event)),
                _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateEndTime('start')))
              ],
              invalid: _ctx.invalid.startTime,
              onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateEndTime('start', $event))),
              placeholder: "09:00"
            }, null, 8, ["modelValue", "invalid"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('calendar.v3.modal.duration')), 1),
            _createVNode(_component_TimeInput, {
              class: "slot-modal-timeInput",
              modelValue: _ctx.slot.duration,
              "onUpdate:modelValue": [
                _cache[6] || (_cache[6] = ($event: any) => ((_ctx.slot.duration) = $event)),
                _cache[7] || (_cache[7] = ($event: any) => (_ctx.updateEndTime('duration')))
              ],
              invalid: _ctx.invalid.endTime,
              onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.updateEndTime('duration', $event))),
              placeholder: "01:00"
            }, null, 8, ["modelValue", "invalid"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('calendar.v3.modal.end_time')), 1),
            _createVNode(_component_TimeInput, {
              class: "slot-modal-timeInput",
              modelValue: _ctx.slot.endTime,
              "onUpdate:modelValue": [
                _cache[9] || (_cache[9] = ($event: any) => ((_ctx.slot.endTime) = $event)),
                _cache[10] || (_cache[10] = ($event: any) => (_ctx.updateEndTime('end')))
              ],
              invalid: _ctx.invalid.endTime,
              onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.updateEndTime('end', $event))),
              placeholder: "10:00"
            }, null, 8, ["modelValue", "invalid"])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('calendar.v3.modal.limit.title')), 1),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_RadioInput, {
              name: "slotLimit",
              value: "count",
              modelValue: _ctx.slotLimit,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.slotLimit) = $event)),
              class: "radio-select"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('calendar.v3.modal.limit.limited')), 1)
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _withDirectives(_createElementVNode("input", {
              type: "number",
              class: _normalizeClass(["bookit-input slot-limit slot-limit-input form-control d-inline", { invalid: _ctx.invalid.limit }]),
              disabled: _ctx.slotLimit != 'count',
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.slot.limit) = $event)),
              min: "1",
              onKeypress: _cache[14] || (_cache[14] = ($event: any) => (_ctx.filterSlotLimitInput($event))),
              onFocus: _cache[15] || (_cache[15] = ($event: any) => (_ctx.slot.limit = _ctx.slot.limit == 0 ? '' : _ctx.slot.limit)),
              required: ""
            }, null, 42, _hoisted_17), [
              [_vModelText, _ctx.slot.limit]
            ]),
            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('calendar.v3.modal.limit.tickets')), 1)
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_RadioInput, {
              name: "slotLimit",
              value: null,
              modelValue: _ctx.slotLimit,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.slotLimit) = $event)),
              class: "radio-select"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('calendar.v3.modal.limit.unlimited')), 1)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_RadioInput, {
              name: "slotLimit",
              value: "order-qty",
              modelValue: _ctx.slotLimit,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.slotLimit) = $event)),
              class: "radio-select"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('calendar.v3.modal.limit.order-qty')), 1)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    disabled: _ctx.slot.forGroupsDisabled,
                    class: "toggle",
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.slot.forGroups) = $event)),
                    checked: _ctx.slot.forGroups
                  }, null, 8, _hoisted_24), [
                    [_vModelCheckbox, _ctx.slot.forGroups]
                  ]),
                  _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('slot.forGroups')), 1)
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    disabled: _ctx.slot.forIndividualsDisabled,
                    class: "toggle",
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.slot.forIndividuals) = $event)),
                    checked: _ctx.slot.forIndividuals
                  }, null, 8, _hoisted_27), [
                    [_vModelCheckbox, _ctx.slot.forIndividuals]
                  ]),
                  _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t('slot.forIndividuals')), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createVNode(_component_Multiselect, {
              modelValue: _ctx.selectedOrderBlockOption,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.selectedOrderBlockOption) = $event)),
              options: _ctx.orderBlockOptions,
              onChange: _ctx.watchAtOption,
              class: "custom-multiselect-input"
            }, {
              caret: _withCtx(() => [
                _hoisted_31
              ]),
              _: 1
            }, 8, ["modelValue", "options", "onChange"])
          ]),
          (_ctx.slot.blockCreatingNewOrdersBefore)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createVNode(_component_InputNumber, {
                    class: _normalizeClass([{ 'form-controll-multiselect': _ctx.invalid.blockCreatingOrdersBefore }, "custom-input"]),
                    required: "",
                    modelValue: _ctx.slot.orderBlockMinutes,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.slot.orderBlockMinutes) = $event)),
                    min: 0,
                    allowEmpty: true
                  }, null, 8, ["class", "modelValue"]),
                  _createElementVNode("div", _hoisted_34, [
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.selectedOrderBlockType,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.selectedOrderBlockType) = $event)),
                      options: _ctx.orderBlockTypes,
                      onChange: _cache[23] || (_cache[23] = ($event: any) => (_ctx.slot.orderBlockMinutes = null)),
                      class: "custom-multiselect-input"
                    }, {
                      caret: _withCtx(() => [
                        _hoisted_35
                      ]),
                      _: 1
                    }, 8, ["modelValue", "options"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.$t('calendar.v3.modal.extraInfo')), 1),
          _withDirectives(_createElementVNode("textarea", {
            name: "textArea",
            id: "extraInfo",
            class: "bookit-textarea product-textarea resize-off long-description form-control",
            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.slot.extraInfo) = $event)),
            maxlength: "255",
            onChange: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.checkExtraInfo && _ctx.checkExtraInfo(...args)))
          }, "\n    ", 544), [
            [_vModelText, _ctx.slot.extraInfo]
          ])
        ])
      ]),
      _createElementVNode("button", {
        class: "save-button-wrapper popup-bookit-button px-5",
        onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args))),
        type: "button"
      }, _toDisplayString(_ctx.$t('button.save')), 1),
      _createElementVNode("button", {
        class: "close-button-wrapper popup-bookit-button px-5",
        onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args))),
        type: "button"
      }, _toDisplayString(_ctx.$t('button.close')), 1)
    ]),
    _: 1
  }, 8, ["isOpen"]))
}